import { render, staticRenderFns } from "./FoldableCardText.vue?vue&type=template&id=789384b6&"
import script from "./FoldableCardText.vue?vue&type=script&lang=js&"
export * from "./FoldableCardText.vue?vue&type=script&lang=js&"
import style0 from "./FoldableCardText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports